import { render } from "./App.vue?vue&type=template&id=523329ba"
const script = {}

import "./App.vue?vue&type=style&index=0&id=523329ba&lang=scss"
script.render = render

export default script